module.exports = __webpack_public_path__ + "static/media/arrow-top-right.a91b569a.svg";